module.exports = __webpack_public_path__ + "img/limage.636ec5fd.jpeg";